import * as React from 'react'
import { FC, useMemo } from 'react'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { IOption, IProviderProps } from '@user/components/Filters'
import { useGetDivisionsOnMountCached } from '@user/store/divisions/hooks/useGetDivisionsOnMount'
import { selectAllDivisions } from '@user/store/divisions/slice'

export const DivisionProvider: FC<IProviderProps> = ({ render }) => {
  // fetch full list
  const { isFetching: allFetching } = useGetDivisionsOnMountCached()
  const allDivisions = useSelector(selectAllDivisions)

  // fetch distinct list
  const { data: distinctDivisionIds, isFetching: distinctFetching } = useQuery(
    ['filters', 'opp', 'division'],
    async () => {
      const response = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters(
          'opportunities',
          'DivisionId',
        )}`,
      )

      const ids: string[] = await response.json()
      // remove falsey (null) values
      return ids.filter(Boolean)
    },
  )

  const isFetching = allFetching || distinctFetching

  const distinctDivisions: IOption[] = useMemo(() => {
    if (!!distinctDivisionIds) {
      const options: IOption[] = allDivisions
        .filter((lt) => distinctDivisionIds.includes(lt.id))
        .map((lt) => ({
          label: `${lt.name} ${lt.description}`.trim(),
          value: lt.id,
        }))
      return options
    }
    return []
  }, [allDivisions, distinctDivisionIds])

  return <>{render(distinctDivisions, isFetching)}</>
}
DivisionProvider.displayName = 'DivisionProvider'
